export const SaleResult = {
  PENDING: 'PENDING',
  WON: 'WON',
  LOST: 'LOST',
} as const;

export type SaleResult = (typeof SaleResult)[keyof typeof SaleResult];
